import { NoteModel } from './note.model';
export class NoteConceptModel {
  noteConceptId: number = 0;
  noteId: number = 0;
  note: NoteModel = new NoteModel();
  conceptInvoicingId: number = 0;
  storeId: number | null = null;
  value: number = 0;
  ivaRate: number = 0;
  ivaValue: number = 0;
  reteFuenteRate: number = 0;
  reteFuenteValue: number = 0;
  reteIcaRate: number = 0;
  reteIcaValue: number = 0;
  discountValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}